import { Text, type TextProps } from '@mantine/core';

interface DateCellProps extends Omit<TextProps, 'children'> {
  /** Значение даты */
  value: Date | string | null | undefined;
  /** Заглушка при пустом / невалидном значении (по умолчанию "—") */
  fallback?: string;
}

/** Форматирует дату в строку ru-RU (dd.mm.yyyy) */
const formatDate = (value: Date | string): string | null => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('ru-RU');
};

/**
 * Ячейка с форматированием даты (ru-RU).
 *
 * @example
 * cell: ({ row }) => <DateCell value={row.original.operation_date} />
 */
const DateCell = ({ value, fallback = '—', ...textProps }: DateCellProps) => (
  <Text pr={8} {...textProps}>
    {value ? (formatDate(value) ?? fallback) : fallback}
  </Text>
);

export default DateCell;
